import { createSseScope } from "utils/sse";

/**
 * Per-store ownership for the one rephrase stream a user can have in flight.
 *
 * It exists so a scoring response that was already on its way cannot overwrite the suggestions
 * of the turn that replaced it. An abort controller cannot express that: it stops the transport,
 * not the REST call that outlived it.
 */
export const createWritingStreamService = () => {
  const scope = createSseScope();
  const slot = { current: null };

  let turns = 0;
  let currentTurn = 0;

  return {
    slot,
    beginTurn: () => {
      turns += 1;
      currentTurn = turns;
      const lease = scope.begin();
      return { lease, turn: turns };
    },
    /**
     * Whether this turn still owns the shared streaming state.
     *
     * The lease's end reason is not enough: cancelling one turn and immediately starting
     * another leaves the first labelled "cancelled" rather than "superseded", and it would then
     * clear the flags belonging to the turn that replaced it. React's StrictMode does exactly
     * this on every mount.
     */
    ownsSharedState: (turn) => turn === currentTurn,
    cancel: (reason = "cancelled") => scope.abortCurrent(reason),
    dispose: () => scope.dispose(),
  };
};
